var map = {
	"./en/btn_1_2.png": "O+rQ",
	"./es/btn_1_2.png": "DK8S",
	"./pt/btn_1_2.png": "M0o3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VcDO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_1_2\.png$
// module id = VcDO
// module chunks = 0